import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActiveCurrencyRequestModel,
  ActiveCurrencyResponseModel,
  DeleteCurrencyRequestModel,
  DeleteCurrencyResponseModel,
  GetCurrencyRequestModel,
  GetCurrencyResponseModel,
  InactiveCurrencyRequestModel,
  InactiveCurrencyResponseModel,
  ListCurrencyRequestModel,
  ListCurrencyResponseModel,
  SaveCurrencyRequestModel,
  SaveCurrencyResponseModel,
} from 'models/setting/currency/currency.model';

export function getCurrency(payload: GetCurrencyRequestModel) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetCurrencyResponseModel,
      GetCurrencyResponseModel
    >(`${PREFIX_API.GENERAL}/currencies/${payload?.id}`);
  }
}

export function listCurrency(payload: ListCurrencyRequestModel) {
  return authorizedRequest.get<
    ListCurrencyResponseModel,
    ListCurrencyResponseModel
  >(`${PREFIX_API.GENERAL}/currencies?${preprocessGetQuery(payload)}`);
}

export function createCurrency(payload: SaveCurrencyRequestModel) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SaveCurrencyResponseModel,
    SaveCurrencyResponseModel
  >(`${PREFIX_API.GENERAL}/currencies`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateCurrency(payload: SaveCurrencyRequestModel) {
  const formDataPayload = getFormData(payload);

  if (payload?.id) {
    return authorizedRequest.put<
      SaveCurrencyResponseModel,
      SaveCurrencyResponseModel
    >(`${PREFIX_API.GENERAL}/currencies/${payload?.id}`, formDataPayload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export function deleteCurrency(payload: DeleteCurrencyRequestModel) {
  return authorizedRequest.delete<
    DeleteCurrencyResponseModel,
    DeleteCurrencyResponseModel
  >(`${PREFIX_API.GENERAL}/currencies/${payload?.id}`);
}

export function inactiveCurrency(payload: InactiveCurrencyRequestModel) {
  return authorizedRequest.put<
    InactiveCurrencyResponseModel,
    InactiveCurrencyResponseModel
  >(`${PREFIX_API.GENERAL}/currencies/${payload?.id}/inactive`);
}

export function activeCurrency(payload: ActiveCurrencyRequestModel) {
  return authorizedRequest.put<
    ActiveCurrencyResponseModel,
    ActiveCurrencyResponseModel
  >(`${PREFIX_API.GENERAL}/currencies/${payload?.id}/active`);
}
